import React from 'react';
import { StarIcon } from 'lucide-react';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const features = ['📄 100% PDF', '⚡ Acceso Inmediato', '📚 7 Capítulos + 5 Bonos', '🗂️ Plantillas Editables'];
  return <section className="w-full px-4 pt-8 pb-6 bg-gradient-to-b from-gray-50 to-white" data-id="element-84">
      <div className="max-w-3xl mx-auto text-center" data-id="element-85">
        <h1 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 leading-snug" data-id="element-86">
          🦷 Todo lo que no te enseñaron de mecánica dental, en un solo lugar.
        </h1>

        <div className="mb-4 cursor-pointer" onClick={scrollToPurchase} data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/4nVzSx3P2kL8whqka8q7hB/ChatGPT_Image_Jun_5,_2026,_12_26_10_AM.png" alt="Mecánica Dental: de 0 a Laboratorio" className="w-full max-w-md mx-auto rounded-lg shadow-2xl hover:shadow-xl transition-shadow duration-300" data-id="element-88" />
        </div>

        <p className="text-sm md:text-base text-gray-600 mb-4 leading-relaxed max-w-2xl mx-auto" data-id="element-89">
          Un sistema paso a paso que te ayuda a dominar la mecánica dental
          moderna, reducir errores, trabajar con más seguridad y prepararte para
          conseguir mejores oportunidades laborales dentro del laboratorio.
        </p>

        <div className="flex flex-wrap justify-center gap-2 mb-3" data-id="element-90">
          {features.map((feature, index) => <span key={index} className="text-xs md:text-sm font-medium text-gray-800 bg-gray-100 px-3 py-1.5 rounded-full" data-id="element-91">
              {feature}
            </span>)}
        </div>

        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-92">
          <div className="flex gap-0.5" data-id="element-93">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-94" />)}
          </div>
          <span className="text-base font-semibold text-gray-900" data-id="element-95">4.9/5.0</span>
        </div>

        <button onClick={scrollToPurchase} className="bg-green-600 hover:bg-green-700 text-white font-bold py-3.5 px-8 rounded-lg text-lg transition-colors duration-200 shadow-lg hover:shadow-xl" data-id="element-96">
          Quiero dominar el laboratorio
        </button>
      </div>
    </section>;
}